import { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
import Switch from '@mui/material/Switch';
import { SecondaryMenuItemTitle } from '../../../component';
import type { RootState } from '../../../../grid/reduxStore/Store';
import { selectContentTableRows } from '../../../../grid/reduxStore/editorSlice';
import { useTableRowManipulation } from './useTableRowManipulation';
import { SelectionContext } from '../../../../GridDndEditor/SelectedBlockInfoProvider';
import { isGeneratedRow } from '../../../../grid/reduxStore/crmRowMarkers';

const OptionalRowToggle = ({ rowId }: { rowId: string }) => {
  const { selectedBlockIdByWrapper, selectedSectionId } = useContext(SelectionContext);
  const sectionId = selectedSectionId as string;
  const blockId = selectedBlockIdByWrapper as string;
  const tableRows = useSelector((state: RootState) => selectContentTableRows(state, sectionId, blockId)) || [];
  const { t } = useTranslation();
  const { toggleRowProperty } = useTableRowManipulation();
  const [isToggleAvailable, setIsToggleAvailable] = useState<boolean>(true);
  const selectedRow = tableRows.find((row) => row.id === rowId);
  const isOptionalToggleAvailable = selectedRow?.isOptionalToggleAvailable ?? false;
  const optionalRowLabel = { inputProps: { 'aria-label': 'Optional row' } };

  const handleSwitchChange = async () => {
    setIsToggleAvailable(false);
    try {
      await toggleRowProperty('isOptionalToggleAvailable', !isOptionalToggleAvailable, rowId);
      setIsToggleAvailable(true);
    } catch (error) {
      setIsToggleAvailable(true);
      throw new Error('Failed to toggle row optional property');
    }
  };

  return (
    <>
      <SecondaryMenuItemTitle>{t('document.grid.table.setting.optional_row')}</SecondaryMenuItemTitle>
      <Grid>
        <Switch
          disabled={!isToggleAvailable || isGeneratedRow(selectedRow)}
          data-testid="pricing-row-optional-toggle"
          {...optionalRowLabel}
          checked={isOptionalToggleAvailable}
          onChange={handleSwitchChange}
        />
      </Grid>
    </>
  );
};

export default OptionalRowToggle;
